import React from 'react';
import { ConnectedAddSegment } from './AddSegment';
import { CMS } from '../../../../utils/CMS/index';

export const AddSegmentDesktop = () => (
    <ConnectedAddSegment render={
        (onClick, buttonLabel) => (
            <span className="odf-link" onClick={onClick}>
                <span className="odf-icon odf-icon-plus odf-icon-s odf-text-action odf-space-outer-right-xs" style={{ textDecoration: 'none' }} />
                <span className="odf-text-md">
                    <CMS id={buttonLabel} />
                </span>
            </span>
        )
    }
    />
);
